/**
 * Unescape a possible HTML escaped string.
 *
 * @param s Possible HTML encoded string.
 * @returns The decoded HTML string; Otherwise, `s`.
 */
export const parse = (s: string) => {
  return new DOMParser().parseFromString(s, 'text/html').documentElement.textContent ?? s;
};
